import * as _ from 'lodash';
import * as utility from '../misc/utility';

import { TromanError } from '../../common/TromanError';

import { Division } from '../objects/Division';
import { MandatePeriod } from '../objects/MandatePeriod';
import { Meeting } from '../objects/Meeting';
import { Mission } from '../objects/Mission';
import { MissionType } from '../objects/MissionType';
import { Organization } from '../objects/Organization';
import { OrganizationType } from '../objects/OrganizationType';
import { Party } from '../objects/Party';
import { Person } from '../objects/Person';
import { WageGroup } from '../objects/WageGroup';
import { WageType } from '../objects/WageType';
import { Attendance } from '../objects/Attendance';
import { PaymentRound } from '../objects/PaymentRound';
import { WageCalculation } from '../objects/WageCalculation';
import { Payment } from '../objects/Payment';
import { PolitikerSettings } from '../objects/PolitikerSettings';
import { Claim } from '../objects/Claim';

export class ResponseContext {

    constructor(objects) {
        var self = this;
        this.objects = {};
        objects.forEach(function (x) {
            self.objects[x.Id] = x;
        });
        this.built = {};
    }

    _getObject(constructor, id) {
        if (id == null) throw new TypeError('Expected Guid, got null');
        if (!utility.isGuid(id)) throw new TypeError('Expected Guid, got ' + typeof id);

        let existing = this.built[id];
        if (existing != null) {
            return existing;
        }

        let src = this.objects[id];
        if (src == null) {
            throw new TromanError('response_missing_id');
        }

        let obj = new constructor(src);
        this.built[id] = obj;
        obj.resolve(this, src);
        return obj;
    }

    get(id, constructor) {
        if (_.isArray(id)) {
            return id.map(this._getObject.bind(this, constructor));
        } else if (id != null) {
            return this._getObject(constructor, id);
        }
    }

    /**
     * 
     * @param {string} id
     * @returns {Person}
     */
    getPerson(id) {
        return this.get(id, Person);
    }

    /**
     *
     * @param {string} id
     * @returns {Mission}
     */
    getMission(id) {
        return this.get(id, Mission);
    }

    /**
     *
     * @param {string} id
     * @returns {Organization}
     */
    getOrganization(id) {
        return this.get(id, Organization);
    }

    /**
     *
     * @param {string} id
     * @returns {Meeting}
     */
    getMeeting(id) {
        return this.get(id, Meeting);
    }

    /**
     *
     * @param {string} id
     * @returns {Division}
     */
    getDivision(id) {
        return this.get(id, Division);
    }

    /**
     *
     * @param {string} id
     * @returns {MissionType}
     */
    getMissionType(id) {
        return this.get(id, MissionType);
    }

    /**
     *
     * @param {string} id
     * @returns {OrganizationType}
     */
    getOrganizationType(id) {
        return this.get(id, OrganizationType);
    }

    /**
     *
     * @param {string} id
     * @returns {Party}
     */
    getParty(id) {
        return this.get(id, Party);
    }

    /**
     *
     * @param {string} id
     * @returns {MandatePeriod}
     */
    getMandatePeriod(id) {
        return this.get(id, MandatePeriod);
    }

    /**
     *
     * @param {string} id
     * @returns {WageGroup}
     */
    getWageGroup(id) {
        return this.get(id, WageGroup);
    }

    /**
     *
     * @param {string} id
     * @returns {WageType}
     */
    getWageType(id) {
        return this.get(id, WageType);
    }

    /**
     *
     * @param {string} id
     * @returns {WageCalculation}
     */
    getWageCalculation(id) {
        return this.get(id, WageCalculation);
    }

    /**
     *
     * @param {string} id
     * @returns {Attendance}
     */
    getAttendance(id) {
        return this.get(id, Attendance);
    }

    /**
     *
     * @param {string} id
     * @returns {PaymentRound}
     */
    getPaymentRound(id) {
        return this.get(id, PaymentRound);
    }

    /**
     *
     * @param {string} id
     * @returns {Payment}
     */
    getPayment(id) {
        return this.get(id, Payment);
    }

    /**
     *
     * @param {string} id
     * @returns {PolitikerSettings}
     */
    getPolitikerSettings(id) {
        return this.get(id, PolitikerSettings);
    }

    /**
     *
     * @param {string} id
     * @returns {Claim}
     */
    getClaim(id) {
        return this.get(id, Claim);
    }
}
